<template>
  <div class="html-editor">
    <Codemirror v-model="model" :extensions="cmOptions" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Codemirror } from 'vue-codemirror'
import { html } from '@codemirror/lang-html'
import { EditorView, keymap } from '@codemirror/view'
import { defaultKeymap } from '@codemirror/commands'

const model = defineModel()

const cmOptions = ref([
  html(),
  EditorView.lineWrapping,
  keymap.of(defaultKeymap)
])
</script>
